export default {"src":"/_next/static/media/logo.312e8922.svg","height":48,"width":195};